import { isLocalUrl, getWindowSize, addTargetAttribute } from '../helpers';

export default function mainCards() {
  const widgetName = 'mainCards';
  const widgetOpts = mainCardsOpts;
  const wrapContainerClass = 'mainCards-container-wrapper';
  const $widget = $(`#${widgetName}`);
  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: getWindowSize(800) ? [] : ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      $cardItem.wrap(`<div class="card-widget-wrapper"></div>`);
      $cardItem.find('.image-container').append('<div class="overlay"></div>');
      const $wrapper = $cardItem.parent('.card-widget-wrapper');

      for (let i = 1; i <= 4; i++) {
        $wrapper.prepend(`<div class="outer-border outer-${i}"></div>`);
      }

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}
              </span>
            </div>
            <div class="hover-content">
              ${URL ? `<a href="${URL}" class="button" ${addTargetAttribute(URL)}>More</a>` : ''}
            </div>
          </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }

      if (!URL) {
        $cardItem.parent().addClass('empty-card').removeAttr('href');
      }
    });

    $widget.find('.card-widget-item .card-content').each(function () {
      handleHoverEffects(this);
    });
  }
}

const handleHoverEffects = (element) => {
  $(element).hover(
    function () {
      handleHoverIn(this);
    },
    function () {
      handleHoverOut(this);
    },
  );
};

const handleHoverIn = function (element) {
  setTimeout(() => {
    $(element).closest('.card-widget-wrapper').removeClass('hover-out').addClass('hover-in');
  }, 200);
};

const handleHoverOut = function (element) {
  setTimeout(() => {
    $(element).closest('.card-widget-wrapper').removeClass('hover-in').addClass('hover-out');
    setTimeout(() => {
      $(element).closest('.card-widget-wrapper').removeClass('hover-out');
    }, 300);
  }, 200);
};
